import { render, staticRenderFns } from "./ApiResourceDetail.vue?vue&type=template&id=3f306085&"
import script from "./ApiResourceDetail.vue?vue&type=script&lang=js&"
export * from "./ApiResourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports